export const updatePathIfRule = (rule: boolean, path: string) => {
	if (rule) {
		window.location.pathname = path;
	}
};
